
import { Tbl_goalEdit } from './tbl_goalEdit';
import { Tbl_goalList } from './tbl_goalList';
import { Tbl_goalShow } from './tbl_goalShow';
import { Tbl_goalCreate } from './tbl_goalCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_goalList,
    edit: Tbl_goalEdit,
    show: Tbl_goalShow,
    create: Tbl_goalCreate,
    icon: MapIcon
};
            